import { useState, useEffect, useCallback } from 'react';
import { getBrief, updateBrief } from '../utils/api';

export default function useBrief(id) {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchBrief = useCallback(async () => {
    if (!id) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await getBrief(id);
      setBrief(data);
    } catch (err) {
      setError(err.message || 'Failed to load brief');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchBrief();
  }, [fetchBrief]);

  const saveBrief = useCallback(async (formData) => {
    if (!id) return null;

    try {
      setSaving(true);
      setError(null);
      const updated = await updateBrief(id, formData);
      setBrief(updated);
      return updated;
    } catch (err) {
      setError(err.message || 'Failed to save brief');
      throw err;
    } finally {
      setSaving(false);
    }
  }, [id]);

  const refresh = useCallback(() => {
    fetchBrief();
  }, [fetchBrief]);

  return {
    brief,
    loading,
    error,
    saving,
    saveBrief,
    refresh,
    setBrief
  };
}
